/* SilvaStone NE portfolio gallery. No dependencies, compatible with Shopify section updates. */
(function () {
  if (window.__ssPortGalleryInstalled) return;
  window.__ssPortGalleryInstalled = true;
  var dialog, image, caption, counter, prev, next, closeButton, items=[], current=0;
  function setup() {
    if (dialog) return;
    dialog = document.createElement('dialog');
    dialog.className = 'ssport-lightbox';
    dialog.setAttribute('aria-label', 'Project photograph viewer');
    dialog.innerHTML = '<div class="ssport-lightbox__top"><span>SILVASTONE NE / PROJECTS</span><button type="button" class="ssport-lightbox__button ssport-lightbox__close" aria-label="Close image viewer">×</button></div><button type="button" class="ssport-lightbox__button ssport-lightbox__nav ssport-lightbox__nav--prev" aria-label="Previous image">‹</button><div class="ssport-lightbox__frame"><img class="ssport-lightbox__image" alt=""><div class="ssport-lightbox__caption" aria-live="polite"></div><span class="ssport-lightbox__count"></span></div><button type="button" class="ssport-lightbox__button ssport-lightbox__nav ssport-lightbox__nav--next" aria-label="Next image">›</button>';
    document.body.appendChild(dialog);
    image=dialog.querySelector('.ssport-lightbox__image'); caption=dialog.querySelector('.ssport-lightbox__caption'); counter=dialog.querySelector('.ssport-lightbox__count'); prev=dialog.querySelector('.ssport-lightbox__nav--prev'); next=dialog.querySelector('.ssport-lightbox__nav--next'); closeButton=dialog.querySelector('.ssport-lightbox__close');
    closeButton.addEventListener('click',function(){dialog.close();});
    prev.addEventListener('click',function(){show(current-1);});
    next.addEventListener('click',function(){show(current+1);});
    dialog.addEventListener('click',function(e){if(e.target===dialog)dialog.close();});
    dialog.addEventListener('keydown',function(e){if(e.key==='ArrowLeft'){e.preventDefault();show(current-1);}if(e.key==='ArrowRight'){e.preventDefault();show(current+1);}});
  }
  function show(index) {
    if(!items.length)return;
    current=(index+items.length)%items.length;
    var el=items[current]; image.src=el.href;image.alt=el.dataset.alt||el.dataset.caption||'SilvaStone NE project photograph';
    caption.textContent=(el.dataset.caption||'')+(el.dataset.category?' · '+el.dataset.category:'');
    counter.textContent=(current+1)+' / '+items.length;
    prev.hidden=items.length<2;next.hidden=items.length<2;
  }
  document.addEventListener('click',function(e){
    var target=e.target.closest && e.target.closest('a[data-ssport-image]');
    if(!target)return;
    if(typeof HTMLDialogElement==='undefined')return;
    e.preventDefault();setup();items=Array.from(document.querySelectorAll('a[data-ssport-image]'));show(items.indexOf(target));
    if(!dialog.open)dialog.showModal();closeButton.focus();
  });
})();
